import { readCookie } from '@zapier/cookies';
import { useState } from 'react';
import { useDeepCompareEffect } from './useDeepCompareEffect';
export const getABTest = (content) => {
    var _a;
    const builderABTestID = readCookie(`builder.tests.${content === null || content === void 0 ? void 0 : content.id}`);
    const variations = content === null || content === void 0 ? void 0 : content.variations;
    if (builderABTestID) {
        const variant_name = ((_a = variations === null || variations === void 0 ? void 0 : variations[builderABTestID]) === null || _a === void 0 ? void 0 : _a.name) || 'control';
        return {
            experiment_flag: true,
            experiment_name: `experiment_name=${content === null || content === void 0 ? void 0 : content.name}--variant_name=${variant_name}`,
            variant_name,
        };
    }
    return { experiment_flag: false };
};
export const useABTest = (content) => {
    const contentID = content === null || content === void 0 ? void 0 : content.id;
    const variations = content === null || content === void 0 ? void 0 : content.variations;
    const [experimentDetails, setExperimentDetails] = useState();
    useDeepCompareEffect(() => {
        if (!contentID)
            return;
        setExperimentDetails(getABTest(content));
    }, [contentID, variations]);
    return experimentDetails;
};
//# sourceMappingURL=useABTest.js.map